import { EntityId } from 'entities-next/common'
import { valueIsInteger } from 'utils/types'

export const MAX_INTEGER_VALUE = 2147483647

export function isValidEntityId(value: unknown): value is EntityId {
  return valueIsInteger(value) && 0 < value && value < MAX_INTEGER_VALUE
}
